import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Dialog } from "@mui/material";
import React from "react";

const ApiLoder = () => {
  return (
    <>
      <div className="spinner_overlay"></div>
      <div className="spinner-box">
        <img
          src="/image/loder.gif"
          alt=""
          className="loading-icon"
          loading="lazy"
        />
      </div>
    </>
  );
};

export const SectionLoader = ({ height = 120, text = "Loading..." }) => (
  <div
    className="d-flex flex-column align-items-center justify-content-center text-muted"
    style={{ height }}
  >
    <span className="spinner-border spinner-border-lg" role="status" />
    {text && <small className="mt-2">{text}</small>}
  </div>
);

export const ButtonSpinner = () => (
  <span
    className="spinner-border spinner-border-sm ms-2"
    role="status"
    aria-hidden="true"
  />
);

const SuccessMessage = (message) => {
  setTimeout(
    () =>
      toast.success(message, {
        position: "top-center",
        autoClose: 2000,
        theme: "colored",
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      }),
    10,
  );
};

const ErrorMessage = (message) => {
  toast.error(message, {
    position: "top-center",
    autoClose: 2000,
    theme: "colored",
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};

const CustomMessages = {
  required: "This field is required.",
  email: "Please enter a valid email address.",
  min: "This field must be at least :min characters.", // :min is a placeholder
  max: "This field must not exceed :max characters.",
  numeric: "Only numbers are allowed.",
  alpha_num: "Only letters and numbers are allowed.",
  alpha_num_space: "Only letters, numbers, and spaces are allowed.",
};

function SubmitButton({ onClick, disabled, text }) {
  return (
    <button
      disabled={disabled}
      type="button"
      onClick={onClick}
      className="btn blue-btn"
    >
      {text}
      {disabled && (
        <i className="fa fa-spinner fa-spin" style={{ marginLeft: "10px" }}></i>
      )}
    </button>
  );
}

const Delete = ({ open, handleClose, handleDelete, title, id, loder }) => {
  return (
    <>
      <Dialog
        open={open}
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": { width: "100%", maxWidth: "480px" },
          },
        }}
      >
        <div
          className="modal fade show"
          tabIndex={-1}
          aria-modal="true"
          role="dialog"
          style={{ display: "block", backgroundColor: "#00000080" }}
        >
          <div className="modal-dialog modal-dialog-centered custom_modal">
            <div className="modal-content">
              <div className="modal-header">
                <h1 className="modal-title">Delete</h1>
                <button type="button" className="btn-close" onClick={handleClose} aria-label="Close">
                  <img src="/image/times-circle.svg" alt="" className="img-fluid" />
                </button>
              </div>
              <div className="modal-body delete_member reset_password">
                <p>
                  You are about to delete{" "}
                  <strong>
                    {title}
                  </strong>

                </p>


                <div class="d-flex justify-content-end gap-3 mt-20">
                  <button className="cancel_btn" type="button" onClick={handleClose}>Cancel</button>
                  <button className="btn btn_meroon catch_btn" type={"button"}
                    disabled={loder}
                    onClick={() => {
                      handleDelete(id);
                    }}
                    style={{ whiteSpace: "nowrap" }}
                  >{loder ? "Deleting.." : "Delete"}
                    {loder && (
                      <i className="fa fa-spinner fa-spin" style={{ marginLeft: "10px" }}></i>
                    )}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Dialog>
    </>
  );
};


const cleanQuillHtml = (html = "") =>
  html
    .replace(/<p><br\s*\/?><\/p>/gi, "")
    .replace(/&nbsp;/g, " ")
    .replace(/\u00a0/g, " ")
    .replace(/\s{2,}/g, " ")
    .trim();

const formatDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
};
const formatShortDate = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

const SendConfirmModal = ({
  open,
  handleClose,
  onConfirm,
  title = "Confirm",
  message = "Are you sure?",
  confirmText = "Confirm",
  variant = "primary",
  icon = "send",
  loading = false,
}) => {
  const SendIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="22" y1="2" x2="11" y2="13" />
      <polygon points="22 2 15 22 11 13 2 9 22 2" />
    </svg>
  );

  const WarningIcon = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
      <line x1="12" y1="9" x2="12" y2="13" />
      <line x1="12" y1="17" x2="12.01" y2="17" />
    </svg>
  );

  return (
    <Dialog
      open={open}
      fullWidth={true}
      maxWidth={"xs"}
      aria-labelledby="send-confirm-title"
    >
      <div
        className="modal fade show"
        id="contactModal"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-modal="true"
        role="dialog"
        style={{ display: "block", backgroundColor: "#00000080" }}
      >
        <div className="modal-dialog modal-dialog-centered custom_modal">
          <div className="modal-content">
            <div className="modal-body logout-popup text-center">
              <span className="mx-auto">
                {icon === "warning" ? <WarningIcon /> : <SendIcon />}
              </span>

              <h3>{title}</h3>

              <p>{message}</p>

              <div className="save_btn">
                <button
                  type="button"
                  className="btn border-btn me-2"
                  onClick={handleClose}
                  disabled={loading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className={`btn btn_meroon catch_btn ${variant === "danger" ? "btn-danger" : "blue-btn"}`}
                  onClick={onConfirm}
                  disabled={loading}
                >
                  {loading ? (
                    <>
                      {confirmText}
                       <i className="fa fa-spinner fa-spin" style={{ marginLeft: "10px" }}></i>
                    </>
                  ) : (
                    confirmText
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}


const maskEmail = (email) => {
  if (!email || !email.includes("@")) return email || "";
  const [name, domain] = email.split("@");
  const visible = name.slice(0, 3);
  const masked = "*".repeat(Math.max(4, name.length - 3));
  const domTail = domain.length > 8 ? domain.slice(-7) : domain;
  return `${visible}${masked}@${domTail}`;
};


export {
  ApiLoder,
  ErrorMessage,
  SuccessMessage,
  CustomMessages,
  SubmitButton,
  Delete,
  SendConfirmModal,
  maskEmail,
  formatDate,
  formatShortDate,
  cleanQuillHtml
};
